export default __webpack_public_path__ + "static/media/cardiacTest.a2012a6c.svg";